// 요청 시점의 화면만 전달한다. URL 쿼리와 해시는 진단 헤더에 포함하지 않는다.
export function attachRequestPage (config, route) {
  config.headers = config.headers || {}
  const path = value => {
    const result = String(value || '').split(/[?#]/, 1)[0]
    return result.startsWith('/') && !result.startsWith('//') && !/[\u0000-\u001f\u007f\\]/.test(result)
      ? Array.from(result).slice(0, 500).join('') : ''
  }
  const page = path((route?.name || route?.matched?.length) ? route.path : window.location.pathname)
  const target = path(config.monitorTargetPath)
  const name = typeof route?.name === 'string' ? Array.from(route.name).slice(0, 100).join('') : ''
  if (page) config.headers['X-Client-Page'] = encodeURIComponent(page)
  if (name) config.headers['X-Client-Page-Name'] = encodeURIComponent(name)
  if (target) config.headers['X-Client-Target-Page'] = encodeURIComponent(target)
  return config
}
